import { useVariant } from '@unleash/proxy-client-react'

export const useIsVariantEnabled = (
  featureFlag: string,
  variantName: string
) => {
  const variant = useVariant(featureFlag)

  return variant.name === variantName && variant.enabled
}
